import React, { useEffect, useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import PixSvg from '../Assets/icons/PixSvg.svg';
import axiosInstance from '../Services/Api';

const CheckoutPixPayment = ({ qrCode, orderId }) => {
    const [success, setSuccess] = useState(false);

    const handleCopy = () => {
        navigator.clipboard.writeText(qrCode)
            .then(() => {
                alert('QR Code copiado para a área de transferência!');
            })
            .catch(err => {
                console.error('Erro ao copiar o QR Code: ', err);
            });
    };

    useEffect(() => {
        const intervalId = setInterval(async () => {
            try {
                const response = await axiosInstance.post('/checkout/orderStatus', { orderId });
                if (response.data.status === 1) {
                    setSuccess(true);
                    clearInterval(intervalId);
                }
            } catch (error) {
                console.error('Erro ao verificar status do pedido:', error);
            }
        }, 5000);

        return () => clearInterval(intervalId);
    }, [orderId]);

    if (success) {
        return (
            <div className="w-full flex flex-col items-center gap-4 border border-[#CFD8DE] rounded-[8px] p-6 md:w-[50%] text-center">
                <div className="text-6xl animate-bounce">🎉</div>
                <h2 className="text-2xl font-bold text-green-600 flex items-center gap-2">
                    <span>✅</span>
                    Pagamento Aprovado!
                    <span>✅</span>
                </h2>
                <p className="text-lg text-gray-700">
                    Obrigado pela sua compra! 💖<br />
                    Você receberá uma confirmação no e-mail fornecido em instantes. 📨<br />
                    <span className="text-sm block mt-2">💰 Seu pedido já está sendo processado!</span>
                </p>
                <div className="text-4xl mt-2">🎊</div>
            </div>
        );
    }

    return (
        <div className="w-full flex flex-col items-center gap-3 border border-[#CFD8DE] rounded-[8px] p-4 md:w-[50%]">
            <img src={PixSvg} alt="Ícone do Pix" className="w-25 h-25" />

            <ol className="list-decimal pl-5 text-[12px] text-[#333]">
                <li>Abra o app do seu banco e entre na opção <strong>Pix</strong>.</li>
                <li>Escolha a opção <strong>Pagar / Pix copia e cola</strong>.</li>
                <li>Escaneie o QR code. Se preferir, copie e cole o código.</li>
                <li>Depois, confirme o pagamento.</li>
                <li>Após confirmado você receberá uma confirmação no e-mail colocado.</li>
            </ol>
            <p className="text-[12px] text-[#333] mt-2">
                A aprovação leva no máximo 2 minutos.
            </p>

            <QRCodeSVG value={qrCode} size={128} />

            <div
                className='px-2 p-1 rounded-[8px] w-full bg-[#478DF8] flex justify-center max-w-[60%] text-[white] cursor-pointer'
                onClick={handleCopy}
            >
                Copiar QR Code
            </div>
        </div>
    );
}

export default CheckoutPixPayment;